import { useEffect, useState } from "react";
import { EvaluationCriteriaService } from "../services/EvaluationCriteriaService";
import { ApiKeyOrGetter } from "../services/GeneralService";

let _deterministicTypes: Set<string> = new Set();
let _initPromise: Promise<void> | null = null;

export function isDeterministicType(type: string): boolean {
  return _deterministicTypes.has(type);
}

export function getDeterministicTypes(): Set<string> {
  return _deterministicTypes;
}

function fetchAndCache(apiKey: ApiKeyOrGetter): Promise<void> {
  return new Promise<void>((resolve) => {
    EvaluationCriteriaService.getAvailable(() => {}, apiKey).subscribe(
      (data: any) => {
        const types: string[] = data.deterministic_types || [];
        _deterministicTypes = new Set(types);
        resolve();
      },
      () => resolve()
    );
  });
}

/**
 * React hook — fetches the catalog once, caches the deterministic types set,
 * and triggers a re-render when loaded.  Subsequent calls across any component
 * reuse the same cached set.
 */
export function useDeterministicTypes(apiKey: ApiKeyOrGetter): Set<string> {
  const [types, setTypes] = useState<Set<string>>(_deterministicTypes);

  useEffect(() => {
    if (_deterministicTypes.size > 0) return;
    if (!_initPromise) {
      _initPromise = fetchAndCache(apiKey);
    }
    _initPromise.then(() => setTypes(new Set(_deterministicTypes)));
  }, [apiKey]);

  return types;
}
